// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.excel-upload-input[data-v-70afa036] {\n  display: none;\n  z-index: -9999;\n}\n", ""]);
// Exports
module.exports = exports;
